export function parseGraphqlResult(data) {
  if (data === null || data === undefined) return data;

  if (Array.isArray(data)) {
    return data.map(parseGraphqlResult);
  }

  if (typeof data === "object") {
    const parsedObject = {};
    for (const [key, value] of Object.entries(data)) {
      parsedObject[key] = parseGraphqlResult(value);
    }
    return parsedObject;
  }

  if (typeof data === "string") {
    try {
      const trimmed = data.trim();
      if (
        (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
        (trimmed.startsWith("[") && trimmed.endsWith("]"))
      ) {
        return JSON.parse(data);
      }
    } catch (e) {
      return data;
    }
  }

  return data;
}
